module.exports = __webpack_public_path__ + "static/media/get-it-on-google-play.08b50d22.png";